import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';

import Cookies from 'universal-cookie';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Rating } from 'primereact/rating';
import { InputText } from 'primereact/inputtext';

import { environment } from "./util/baseUrl";
import { useNavigate } from 'react-router-dom';
import { AsistenciaEntity } from './Entity/AsistenciaEntity';

const ListaCursos = () => {

    const asistencia = AsistenciaEntity;

    const cookies = new Cookies();

    const navigate = useNavigate();
    const baseUrl = environment.baseUrl + "curso/";
    const [data, setData] = useState(null);
    const [dataViewValue, setDataViewValue] = useState(null);
    const [bloquearBoton, setBloquearBoton] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filteredValue, setFilteredValue] = useState(null);
    const [layout, setLayout] = useState('grid');

    const toast = useRef(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [sortField, setSortField] = useState(null);

    const formatDate = (dateString) => {
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', options);
    };

    const peticionGet = async () => {
        await axios.get(baseUrl + 'lista')
            .then(response => {
                setDataViewValue(response.data);
            }).catch(error => {
                console.log(error);
            })
    }

    const AgregarRegistro = async (idcurso) => {
        if (!cookies.get('id')) {
            return toast.current.show({ severity: 'error', summary: 'Datos Incorrectos', detail: 'Usuario no logeado', life: 5000 });
        } else {
            asistencia.user.id = cookies.get('id');
            asistencia.curso.id = idcurso;
            asistencia.user.role = cookies.get('role');
        }
        asistencia.fecRegistro = formatDate(new Date());
        console.log(asistencia);
        delete asistencia.id;
        await axios.post(environment.baseUrl + 'asistenciacurso/', asistencia)
            .then(() => {
                toast.current.show({ severity: 'success', summary: 'Registro Correcto', detail: 'Se registro la asistencia a ', life: 3000 });
            }).catch(error => {
                console.log(error);
                toast.current.show({ severity: 'error', summary: 'Datos Incorrectos', detail: 'Datos Incorrectos', life: 5000 });
            })
    }

    useEffect(() => {
        peticionGet()
    }, []);

    const redirectToLink = (url) => {
        window.open(url);
    };

    const bloquearBotonSeg = () => {
        setBloquearBoton(true); // Deshabilitar el botón
        setTimeout(() => {
            setBloquearBoton(false);
        }, 12000);
    };

    const onFilter = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
        if (value.length === 0) {
            setFilteredValue(null);
        } else {
            const filtered = dataViewValue.filter((product) => {
                return product.titulo.includes(value);
            });
            setFilteredValue(filtered);
        }
    };


    const dataViewHeader = (
        <div className="flex flex-column md:flex-row md:justify-content-between gap-2">
            {/* <Dropdown value={sortKey} options={sortOptions} optionLabel="label" placeholder="Sort By Price" onChange={onSortChange} /> */}
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onFilter} placeholder="Buscar por titulo" />
            </span>
            <DataViewLayoutOptions layout={layout} onChange={(e) => setLayout(e.value)} />
        </div>
    );

    const dataviewListItem = (data) => {
        return (
            <div className="col-12">
                <div className="flex flex-column md:flex-row align-items-center p-3 w-full">
                    <img src={"/imagenes/" + data.codigo + ".jpg"} alt={data.titulo} className="my-4 md:my-0 w-9 md:w-10rem shadow-2 mr-5"
                        onError={(e) => {
                            e.target.src = "/logos/logoua.png";
                            e.target.style.transform = "scale(0.5)"; // Reduce al 50%
                            e.target.style.objectFit = "contain"; // Evita deformaciones
                        }} />
                    <div className="flex-1 flex flex-column align-items-center text-center md:text-left">
                        <div className="font-bold text-2xl">{data.titulo}</div>
                        <div className="mb-2">{data.ponente}</div>
                        <Rating value="5" readOnly cancel={false} className="mb-2"></Rating>
                        <div className="flex align-items-center">
                            <i className="pi pi-tag mr-2"></i>
                            <span className="font-semibold">{data.categoria.titulo}</span>
                        </div>
                    </div>
                    <div className="flex align-items-center justify-content-between">
                        <div className="flex flex-column align-items-center text-center mb-3">
                            <Button title="Inscribirme" icon="pi pi-check" className="p-button-rounded p-button-outlined p-button mr-2"
                                onClick={() => { AgregarRegistro(data.id); bloquearBotonSeg(); }} disabled={bloquearBoton} />
                            <span className="font-semibold mr-4">Inscribirme</span>
                        </div>
                        <div className="flex flex-column align-items-center text-center mb-3">
                            <Button title="Ver conferencia" icon="pi pi-video" disabled={data.activo === false} onClick={() => redirectToLink(data.video)} className="p-button-rounded p-button-outlined p-button mr-2" />
                            <span className="font-semibold mr-4">Ver conferencia</span>
                        </div>
                        <div className="flex flex-column align-items-center text-center mb-3">
                            <Button title="Ver materiales" icon="pi pi-book" disabled={data.activo === false} onClick={() => redirectToLink(data.material)} className="p-button-rounded p-button-outlined p-button mr-2" />
                            <span className="font-semibold">Materiales</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const dataviewGridItem = (data) => {
        return (
            <div className="col-12 lg:col-4">
                <div className="card m-3 border-1 surface-border" >
                    <div className="flex flex-wrap gap-2 align-items-center justify-content-between mb-2">
                        <div className="flex align-items-center">
                            <i className="pi pi-tag mr-2" />
                            <span className="font-semibold">{data.categoria.titulo}</span>
                        </div>
                        <span className={`product-badge status-`}>{data.inventoryStatus}</span>
                    </div>
                    <div className="flex flex-column align-items-center text-center mb-3">
                        <img src={"/imagenes/" + data.codigo + ".jpg"} alt={data.titulo} className="w-5 shadow-2 my-3 mx-0"
                            onError={(e) => {
                                e.target.src = "/logos/logoua.png";
                                e.target.style.transform = "scale(0.5)"; // Reduce al 50%
                                e.target.style.objectFit = "contain"; // Evita deformaciones
                            }} />
                        <div className="text-2xl font-bold">{data.titulo}</div>
                        <div className="mb-3">{data.ponente}</div>
                        <Rating value="5" readOnly cancel={false} />
                    </div>
                    <br />
                    <div className="flex align-items-center justify-content-between">
                    <div className="flex flex-column align-items-center text-center mb-3">
                            <Button title="Inscribirme" icon="pi pi-check" className="p-button-rounded p-button-outlined p-button mr-2"
                                onClick={() => { AgregarRegistro(data.id); bloquearBotonSeg(); }} disabled={bloquearBoton} />
                            <span className="font-semibold mr-4">Inscribirme</span>
                        </div>
                        <div className="flex flex-column align-items-center text-center mb-3">
                            <Button title="Ver conferencia" icon="pi pi-video" disabled={data.activo === false} onClick={() => redirectToLink(data.video)} className="p-button-rounded p-button-outlined p-button mr-2" />
                            <span className="font-semibold mr-4">Ver conferencia</span>
                        </div>
                        <div className="flex flex-column align-items-center text-center mb-3">
                            <Button title="Ver materiales" icon="pi pi-book" disabled={data.activo === false} onClick={() => redirectToLink(data.material)} className="p-button-rounded p-button-outlined p-button mr-2" />
                            <span className="font-semibold">Materiales</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const itemTemplate = (data, layout) => {
        if (!data) {
            return;
        }

        if (layout === 'list') {
            return dataviewListItem(data);
        } else if (layout === 'grid') {
            return dataviewGridItem(data);
        }
    };

    return (
        <div className="grid list-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Button title="Volver" icon="pi pi-arrow-left" className="p-button-rounded p-button-outlined p-button mr-2" onClick={() => { navigate(`/index`); }} />
                    <br />
                    <DataView value={filteredValue || dataViewValue} layout={layout} paginator rows={9} sortOrder={sortOrder} sortField={sortField} itemTemplate={itemTemplate} header={dataViewHeader}></DataView>
                </div>
            </div>
        </div>
    );
};

export default ListaCursos;